import { EventAction } from './EventActions';
import { ModalProcessor } from './processors/ModalProcessor';
import { EventSubprocessor } from 'modules/eventReceiver/EventSubprocessor';
import { getService } from 'data/function';
// Processor defined prefix
export const PROCESSOR_PREFIX = 'Tenant';
// Tenant application event processor
export class TenantEventProcessor extends EventSubprocessor {
    static get TenantService() {
        return getService('TenantService');
    }
    static async process(payload) {
        const action = this.removeProcessorPrefix(payload.message.action, PROCESSOR_PREFIX);
        switch (action) {
            case EventAction.ShowModal:
                await ModalProcessor.process(payload);
                break;
            case EventAction.Url:
                payload.source.postMessage({
                    response: this.TenantService.getTenantUrl(payload.message.content),
                    trackingProperties: payload.trackingProperties,
                }, '*');
                break;
            default:
                throw `[TenantProcessor] No processor available for action ${action}`;
        }
    }
}
